<template>
  <div>
    <md-card-content>
      <h5>{{$t('games.messages.title')}}</h5>
      <md-button class="md-wd" @click="message.text = $t('games.messages.fixedMessage.flag')">{{$t('games.messages.fixedMessageTitle.flag')}}</md-button> 
      <md-button class="md-wd" @click="message.text = $t('games.messages.fixedMessage.animate1')">{{$t('games.messages.fixedMessageTitle.animate1')}}</md-button> 
      <md-button class="md-wd" @click="message.text = $t('games.messages.fixedMessage.animate2')">{{$t('games.messages.fixedMessageTitle.animate2')}}</md-button> 
      <md-button class="md-wd" @click="message.text = $t('games.messages.fixedMessage.close')">{{$t('games.messages.fixedMessageTitle.close')}}</md-button> 
    </md-card-content>
    <md-card-content>
      <md-field :class="{'md-error': errorTotalLength}">
        <label>{{$t('games.messages.message')}}</label>
        <md-input v-model="message.text"></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="errorTotalLength">close</md-icon>
        </slide-y-down-transition>
      </md-field>
      <small class="text-danger" v-if="errorTotalLength">
        {{$t('games.messages.errorMaxLength')}}
      </small>
      <p class="text-info">{{$t('games.messages.innerLink')}}</p>
      <md-field>
        <label>{{$t('games.messages.link')}}</label>
        <md-input v-model="message.link" :disabled="!message.text.includes('*link*')"></md-input>
      </md-field>
      <md-field>
        <label>{{$t('games.messages.linkName')}}</label>
        <md-input v-model="message.linkName" :disabled="!message.text.includes('*link*')"></md-input>
      </md-field>
      <md-card v-if="message.text != ''">
        <md-card-header>
          <div class="md-subtitle">{{$t("games.messages.previewMessage")}}</div>
        </md-card-header>
        <md-card-content>
          <div v-html="formatterMessage()"></div>
        </md-card-content>
      </md-card>
      <md-button class="md-block md-success button-messages" @click="sendMessage(teamId)" :disabled="message.text == '' || errorTotalLength" >{{$t('games.messages.send')}}</md-button>
    </md-card-content>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    teamId: Number,
    gameId: Number
  },
  data() {
    return {
      maxLengthMessage: 150,
      message: {
        text: "",
        link:"",
        linkName: ""
      }
    }
  },
  computed: {
    errorTotalLength() {
      return (this.message.text.replace("*link*", "").length + this.message.linkName.length) > 150
    }
  },
  methods: {
    async sendMessage(teamId) {
      const params = {
        teamId,
        gameId: this.gameId,
        message: this.formatterMessage()
      }
      const response = await this.$store.dispatch('sendMessage', params)
      if (response != undefined) {
        this.$notify({
          message: this.$t(`notifications.game.sendMessage`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
      } else {
        this.$store.dispatch("openModalError")
      }
    },
    formatterMessage() {
      return this.message.text.replace("*link*", `<a href="#" onclick="window.open('${this.message.link}', '_system')">${this.message.linkName}</a>`)
    }
  }
}
</script>

<style lang="scss">
.button-messages {
  margin-top: 32px;
}
</style>